export default __webpack_public_path__ + "static/media/news41.6d4f7dc4.jpg";